export default "__VITE_ASSET__BvafIQKh__"